import styled from 'styled-components';

export const InputItem = styled.div``;
